var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "600px",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "100px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商编号", prop: "Code" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "供应商编号自动生成",
                          disabled: "",
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商名称", prop: "Name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入供应商名账号" },
                        model: {
                          value: _vm.form.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Name", $$v)
                          },
                          expression: "form.Name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商类型", prop: "Type" } },
                    [
                      _c("SelectDicValue", {
                        ref: "SelectDicValue",
                        attrs: { code: "SupplierType" },
                        model: {
                          value: _vm.form.Type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Type", $$v)
                          },
                          expression: "form.Type",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商电话", prop: "Phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入供应商名电话" },
                        model: {
                          value: _vm.form.Phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Phone", $$v)
                          },
                          expression: "form.Phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人", prop: "ContactName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入供应商联系人" },
                        model: {
                          value: _vm.form.ContactName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ContactName", $$v)
                          },
                          expression: "form.ContactName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商Email", prop: "Email" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入供应商名Email" },
                        model: {
                          value: _vm.form.Email,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Email", $$v)
                          },
                          expression: "form.Email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商状态", prop: "States" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.States,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "States", $$v)
                            },
                            expression: "form.States",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("启用"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("停用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "Remarks" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "",
                          rows: "3",
                          resize: "none",
                        },
                        model: {
                          value: _vm.form.Remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Remarks", $$v)
                          },
                          expression: "form.Remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }